/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

import * as io from 'io-ts';

/**
 * The biller details, and its properties.
 */
export type EntityBillerDetails = io.TypeOf<typeof BillerDetails>;

/**
 * The biller details, and its properties.
 * @export
 */
export const BillerDetails = io.type(
  {
    address: io.string,
    address2: io.string,
    ccEmails: io.string,
    city: io.string,
    country: io.string,
    countryName: io.string,
    createdAt: io.number,
    email: io.string,
    firstName: io.string,
    id: io.number,
    lastName: io.string,
    locale: io.string,
    organization: io.string,
    phone: io.string,
    reference: io.number,
    state: io.string,
    stateName: io.string,
    taxExempt: io.boolean,
    updatedAt: io.number,
    vatNumber: io.string,
    verified: io.boolean,
    zip: io.number,
  },
  `BillerDetails`,
);
